import { Link } from "react-router-dom";
import { useObserver, useSubtree } from "subtree.js/react";
import { LoginActions, LoginState } from "./login-model";

export function LoginPage() {
  const state = useSubtree(LoginState);
  const actions = useSubtree(LoginActions);
  const observer = useObserver();
  const draft = observer.watch(state.draft);
  const errors = observer.watch(state.fieldErrors);
  const error = observer.watch(state.error);
  const info = observer.watch(state.info);
  const loading = observer.watch(state.busy);

  return (
    <div className="flex min-h-screen items-center justify-center bg-app p-4">
      <div className="w-full max-w-sm">
        <div className="mb-8 text-center">
          <h1 className="text-3xl font-bold">
            Hobby<span className="text-accent">Scan</span>.Pro
          </h1>
          <p className="mt-1 text-muted">Sign in to your account</p>
        </div>

        <form
          onSubmit={(e) => {
            e.preventDefault();
            void actions.submit();
          }}
          className="panel space-y-5 p-8"
        >
          {error && <p className="note note-danger text-danger">{error}</p>}
          {info && <p className="note note-accent text-accent">{info}</p>}

          <div>
            <label htmlFor="email" className="label">
              Email
            </label>
            <input
              id="email"
              name="email"
              type="email"
              autoComplete="email"
              placeholder="you@example.com"
              aria-invalid={errors.email ? "true" : "false"}
              aria-describedby={errors.email ? "email-error" : undefined}
              value={draft.email}
              onChange={(e) => actions.setEmail(e.target.value)}
              className="field"
            />
            {errors.email && (
              <p id="email-error" className="field-error">
                {errors.email}
              </p>
            )}
          </div>

          <div>
            <label htmlFor="password" className="label">
              Password
            </label>
            <input
              id="password"
              name="password"
              type="password"
              autoComplete="current-password"
              placeholder="••••••••"
              aria-invalid={errors.password ? "true" : "false"}
              aria-describedby={errors.password ? "password-error" : undefined}
              value={draft.password}
              onChange={(e) => actions.setPassword(e.target.value)}
              className="field"
            />
            {errors.password && (
              <p id="password-error" className="field-error">
                {errors.password}
              </p>
            )}
          </div>

          <button type="submit" disabled={loading} className="btn-primary w-full">
            {loading ? "Signing in…" : "Sign in"}
          </button>

          <div className="flex items-center gap-3">
            <span className="h-px flex-1 bg-line" />
            <span className="text-xs text-faint">or</span>
            <span className="h-px flex-1 bg-line" />
          </div>

          <button
            type="button"
            onClick={() => void actions.continueWithGoogle()}
            disabled={loading}
            className="btn-secondary w-full"
          >
            Continue with Google
          </button>

          {/*todo uncomment in case apple will be configured*/}
          {/*<button*/}
          {/*  type="button"*/}
          {/*  onClick={() => void actions.continueWithApple()}*/}
          {/*  disabled={loading}*/}
          {/*  className="btn-secondary w-full"*/}
          {/*>*/}
          {/*  Continue with Apple*/}
          {/*</button>*/}
        </form>

        <p className="mt-4 text-center text-sm text-muted">
          Don&apos;t have an account?{" "}
          <Link to="/register" className="font-medium text-accent hover:underline">
            Create one
          </Link>
        </p>

        <p className="mt-6 text-center text-xs text-faint">
          <Link to="/privacy" className="hover:underline">
            Privacy Policy
          </Link>
        </p>
      </div>
    </div>
  );
}
